<template>
  <div class="auth-wrapper">
    <div class="auth-box">
      <div class="auth-header">
        <button class="close" @click="goHomepage">&times;</button>
        <div class="header-logo"></div>
        <div class="header-title">Member Login</div>
      </div>
      <div class="auth-body">
        <component :is="activeForm"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import LoginForm from '../components/FormAuth/Login.vue'
import SetupForm from '../components/FormAuth/Setup.vue'
import TokenForm from '../components/FormAuth/Token.vue'
import TermForm from '../components/FormAuth/Term.vue'
import ChangePhoneForm from '../components/FormAuth/ChangePhone.vue'
import ForgotPasswordForm from '../components/FormAuth/ForgotPassword.vue'
import RequestSuccessfulForm from '../components/FormAuth/RequestSuccessful.vue'

export default {
  data() {
    return {
      formsArray: [
        LoginForm,
        SetupForm,
        TokenForm,
        TermForm,
        ChangePhoneForm,
        ForgotPasswordForm,
        RequestSuccessfulForm
      ]
    }
  },
  async created() {
    await this.$store.dispatch('auth/configure')
  },
  computed: {
    ...mapState({authState: state => state.auth.step}),
    activeForm() {
      return this.formsArray[this.authState]
    },
  },
  methods: {
    goHomepage() {
      window.location.href = `http://${window.location.host}`
    }
  },

}
</script>


<style lang="scss">

@import '../../src/assets/scss/elements';

.auth-wrapper {
  @include brand-font-family;
  a {
    @include brand-text-link;
  }
}

</style>

<style lang="scss" scoped>

.auth-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  width: 100vw;
  height: 100vh;

  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(#ccc, .95);
  overflow: auto;
  z-index: 2;

  @media (max-height: 850px) {
    align-items: flex-start;
    padding: 1em 0;
  }
}

.auth-box {
  border: solid 1px #A5A5A5;
  border-radius: 3px;
  background-color: #fff;
  max-width: 500px;
  width: 90vw;
  margin: 2em 0 5em;
  @media (min-width: 600px) {
    width: 50vw;
  }
  @media (min-width: 800px) {
    width: 40vw;
  }
}

.auth-header {
  background-color: #33ADEE;
  text-align: center;
  padding: 2.2em 0 1.6em;
  position: relative;

  .close {
    background: none;
    border: none;
    box-shadow: none;
    position: absolute;
    right: 5px;
    top: 0;
    line-height: 1;
    padding: 3px;
    font-size: 21px;
    font-weight: 700;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: .2;
    cursor: pointer;
    transition: opacity .3s ease;

    &:hover {
      opacity: 1;
    }

  }

  .header-logo {
    height: 80px;
    background: url('../assets/images/liberal-logo-white-type.svg') no-repeat center;
  }

  .header-title {
    margin-top: .8em;
    color: #fff;
    font-size: 1.6rem;
    font-weight: 400;
  }
}

.auth-body {
  padding: 27px 25px;
}
</style>
